<template>
    <div v-if="allowFeedback" class="feedback-wrapper box-shadow-base is-hidden-mobile" :class="{ open: !openFeedbackForm }">
        <div class="feedback-form">
                <div class="feedback-button">
                    <b-button @click="onFeedbackClick" type="is-link">Feedback</b-button>
                </div>
                <b-field class="mb-4">
                    <b-input class="box-shadow-base" v-model="form.email" placeholder="Email address (optional)">
                    </b-input>
                </b-field>
                <b-field>
                    <b-input class="box-shadow-base is-size-6" maxlength="400" placeholder="Please leave your feedback here" v-model="form.content" type="textarea"></b-input>
                </b-field>
                <div class="is-flex is-justify-content-end w-100">
                    <b-button @click="submit" :disabled="isError" type="is-link">Submit</b-button>
                </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    name: 'Feedback',
    components: {
    },
    data() {
        return {
            openFeedbackForm: false,
            allowFeedback: false,
            form: {
                email: "",
                content: "",
                source: "",
            },
            isError: true
        }
    },
    created() {
        this.checkFeedback()
    },
    watch: {
        'form.content': function (val) {
           this.isError = val.trim() ? false : true
        }
    },
    methods :{
        onFeedbackClick() {
            this.openFeedbackForm = !this.openFeedbackForm
        },
        async submit() {
            let source = this.convertToSource(this.$route.name)
            this.form.source = source
            let token = document.head.querySelector('meta[name="csrf-token"]');
            if (token) {
                window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
            } else {
                //console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
            }

            await axios.get('/sanctum/csrf-cookie')
                await axios.post("/feedback", this.form).then(response => {
                    if (response.data.message == "success") {
                        this.$toast.success("Thanks for your feedback!")
                        this.form.email = ''
                        this.form.content = ''
                        this.form.source = ''
                        this.openFeedbackForm = false
                        this.allowFeedback = response.data.data.toggle
                    }
                }).catch((err) => {
                    this.$toast.error(err.message || 'Some thing went wrong, please try again!')
                })
        },

        convertToSource(page){
            let soruce = ''
            switch (page) {
                case 'Home':
                   soruce = 'home_page'
                    break;
                case 'Dashboard':
                    soruce = 'dashboard_page'
                    break;
                case 'Alert':
                    soruce = 'alert_page'
                    break;
                    
                case 'Comparison':
                    soruce = 'comparison_page'
                    break;
                    
                case 'Referral':
                    soruce = 'referral_page'
                    break;
                    
                case 'Watchlist':
                    soruce = 'watchlist_page'
                    break;
                    
                case 'Results':
                    soruce = 'results_page'
                    break;
                case 'Detailedview Shortlist':
                    soruce = 'detailed_page'
                    break;

                case 'Detailedview Results':
                    soruce = 'detailed_page'
                    break;         

                default:
                    break;
            }
            return soruce
        },

        async checkFeedback() {

            let token = document.head.querySelector('meta[name="csrf-token"]');

            if (token) {
                window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
            } else {
                //console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
            }

            await axios.get('/sanctum/csrf-cookie')
            await axios.get("/feedback").then(response => {
                this.allowFeedback = response.data.data.toggle
            }).catch((err) => {
                this.$toast.error(err.message || 'Some thing went wrong, please try again!')
            })
        }
        
    }
}
</script>
<style lang="scss" scoped>
    .feedback-wrapper {
        position: fixed;
        right: 0;
        bottom: 25%;
        background-color: #ffffff;
        width: 320px;
        z-index: 1000;
        border-radius: 4px;
        padding: 42px 24px;
        &.open {
            right: -320px;
        }
        .feedback-form {
            position: relative;
            .feedback-button {
                display: inline-block;
                transform: rotate(90deg);
                position: absolute;
                left: -105px;
                top: -8px;
            }
            .is-link {
                    background-color: #485fc7;
                    color: #ffffff;
                }
        }
    }
    @media only screen and (max-width: 768px) {
        
        .feedback-wrapper { 
            top: 60px;
            height: 320px;
            .feedback-form {
            position: relative;
            .feedback-button {
                left: -80px;
                top: -18px;
            }
            .is-link {
                    width: 80px;
                    height: 32px;
                    font-size: 16px;
                }
            }
        }
    }

    @media only screen and (max-width: 360px) {
        .feedback-wrapper {
            width: 280px;
            &.open {
                right: -280px;
            }
        }
    }
    
</style>
